import { defineComponent as _defineComponent } from 'vue'
import UiLink from '~/components/ui/UiLink.vue';
import UiSectionTitle from '~/components/ui/UiSectionTitle.vue';
import { CdnImg } from '@webplatform/cdn-image';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PartnersSection',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {



return { __sfc: true,UiLink, UiSectionTitle, CdnImg }
}

})